<script context="module">
  import { isNullOrUndefined } from './Utils.svelte';
  class Product {
    constructor(name, re, aliases) {
      this.name = name;
      this.re = new RegExp(re);
      this.aliases = aliases.map(x => x.toLowerCase());
    }

    is_product(name) {
      if (this.name == name) {
        return true;
      }
      return this.aliases.includes(name.toLowerCase());
    }

    has_product(str) {
      return this.re.test(str);
    }
  }

  class Products {
    constructor() {
      this.products = [
          new Product('aspire',         /aspire/i,                      []),
          new Product('vcarve_pro',     /vcarve[\s_-]*pro/i,            ['vcarve-pro', 'vcarvepro']),
          new Product('vcarve_desktop', /vcarve[\s_-]*desktop/i,        ['vcarve-desktop', 'vcarvedesktop']),
          new Product('cut2d_pro',      /cut[\s_-]*2d[\s_-]*pro/i,      ['cut2d-pro', 'cut2dpro']),
          new Product('cut2d_desktop',  /cut[\s_-]*2d[\s_-]*desktop/i,  ['cut2d-desktop', 'cut2ddesktop']),
          new Product('photovcarve',    /photo[\s_-]*v[\s_-]*carve/i,   []),
          new Product('cut3d',          /cut[\s_-]*3d/i,                [])
        ];
    }

    get_product(name) {
      for (let product of this.products) {
        if (product.is_product(name)) {
          return product;
        }
      }
      return null;
    }

    has_product(str) {
      for (let product of this.products) {
        if (product.has_product(str)) {
          return product;
        }
      }
      return null;
    }
  }

  function is_page_served() {
    if (location.protocol.includes('http')) {
      return true;
    } else {
      return false;
    }
  }

  export function inject_whole_app() {
    return !is_page_served();
  }

  function is_cached_data_available() {
    if (content_server_data === undefined || content_server_data == null) {
      return false;
    } else {
      return true;
    }
  }

  export const products = new Products();

  export function show_local_files() {
    return !is_page_served();
  }

  export function fixed_product(orig_product) {
    const url = decodeURI(location.href);
    const product = products.has_product(url);
    if (isNullOrUndefined(product)) {
      console.warn(`Product not recognised from URL "${url}"`);
      return orig_product;
    } else {
      return product.name;
    }
  }

  export function fixed_machinable_state(orig_flag) {
    if (is_page_served()) {
      return orig_flag;
    } else {
      return location.pathname.includes('MachinableIndex.html') ? "true" : orig_flag;
    }
  }

  export async function get_content_data() {
    let fetch_remote = false;
    if (is_page_served()) {
      fetch_remote = true;
    } else {
      if (is_cached_data_available()) {
        // TODO check if we're online and fetch remote in that case?
        fetch_remote = false;
      } else {
        fetch_remote = true;
      }
    }

    if (!fetch_remote) {
      if (content_server_data !== undefined) {
        return Promise.resolve(content_server_data);
      }
    }

    return fetch('https://resources.vectric.com/pretty/templateInstances?template=Ordered%20tutorial%20playlists&labelName=Version%2010.5', {
        cache: "default"
    }).then(response => {
      return response.json();
    });
  }

</script>
